import { useQuery, type UseQueryResult } from 'react-query'

import { useSourcePageService } from 'features/sourcepage/service'
import type { SourcesInfo } from 'features/sourcepage/types'

export const useSourceGroupInfo = (
  sourcename: string,
  syndicated: boolean,
  projectId: string,
  country?: string,
  options?: { enabled?: boolean },
): UseQueryResult<SourcesInfo> => {
  const sourcePageService = useSourcePageService()

  return useQuery(
    ['source_name', sourcename, syndicated, projectId, country],
    () =>
      sourcePageService.getSourceGroupInfo(
        'source_name',
        sourcename,
        syndicated,
        projectId,
        country,
      ),
    { enabled: options?.enabled },
  )
}
